module.exports = __webpack_public_path__ + "img/content_title5.e73f3eb8.png";